import { Outlet, Navigate } from 'react-router-dom'
import { unAuthorizedPageUrl } from '../pages/members/Shared/Constants/AppConstant';
import { useAuth } from '../providers/AuthProvider';
import { Authserverconstants } from '../utils/AuthServerConstants';


const AuthGuard = (props: any) => {
    let auth = useAuth();
    let isAdmin = auth?.isGpDiaryAdmin();
    let isMember = auth?.isGpDiaryMember();
    let isStaff = auth?.isGpDiaryStaff();

    // To redirect to the same page after session time out
    if (!auth?.isAuthenticated()) {
        auth?.signinRedirect();
        return null;
    }

    //Role based protected routes if url entered directly
    if (props.allowedRoles == Authserverconstants.Admin_Features_Url && !(isAdmin)) {
        return <Navigate to={unAuthorizedPageUrl} replace />;
    }

    //Role based protected routes if url entered directly
    if (props.allowedRoles == Authserverconstants.Members_Features_Url && (!(isMember) && !(isStaff))) {
        return <Navigate to={unAuthorizedPageUrl} replace />;
    }

    return (
        auth?.isAuthenticated() ? <Outlet /> : <Navigate to="/" replace />
    )
}

export default AuthGuard